import { graphql } from "@opensea/graphql"
import { AcceptOfferReceiptFragment } from "./components/AcceptOfferReceipt/AcceptOfferReceipt.fragment"
import { AcceptOfferStatus_itemFragment } from "./components/AcceptOfferStatus/AcceptOfferStatus.fragment"
import { AcceptOfferFlowTimeline_quoteFragment } from "./components/AcceptOfferTimeline/AcceptOfferTimeline.fragment"

export const AcceptOfferFlow_quoteFragment = graphql(
  `
    fragment AcceptOfferFlow_quote on Quote {
      itemQuotes {
        __typename
        ... on WithQuoteItem {
          item {
            id
            imageUrl
            __typename
            ...AcceptOfferStatus_item
          }
        }

        ... on ItemNotFound {
          item {
            tokenId
            chain {
              identifier
            }
            contractAddress
            __typename
          }
        }
      }
      ...AcceptOfferReceipt
      ...AcceptOfferFlowTimeline_quote
    }
  `,
  [
    AcceptOfferReceiptFragment,
    AcceptOfferStatus_itemFragment,
    AcceptOfferFlowTimeline_quoteFragment,
  ],
)
